import { t } from '@framework/i18n';
import { LoginBlockStepsPaUsers } from './LoginBlockStepsPaUsers';
import { LoginCol } from './LoginCol';

interface IEmployeeLoginFormProps {
  onLogin?: (response: any) => void;
  resolvePublicUrl: (path: string) => string;
  skipLoginBlock?: boolean;
}

export function EmployeeLoginForm(props: IEmployeeLoginFormProps) {
  const { onLogin, resolvePublicUrl, skipLoginBlock = false } = props;

  return (
    <LoginCol
      style={{ height: '100%' }}
      hasBackground={!skipLoginBlock}
      title={t(
        'user.front-login.title-accesso-dipendenti',
        'Accesso dipendenti',
      )}
    >
      <LoginBlockStepsPaUsers
        onLogin={onLogin}
        resolvePublicUrl={resolvePublicUrl}
        skipLoginBlock={skipLoginBlock}
      />
    </LoginCol>
  );
}
